import { section } from '@/neon';

import scrollIntoView from '@/lib/scrollIntoView';

const selectors = {
  animatedItems: '.animates',
};

section('collection-list-grid', {
  onLoad() {
    this.animatedItems = this.container.querySelectorAll(
      selectors.animatedItems
    );

    if (this.animatedItems.length) {
      this.scrollAnimation = scrollIntoView(this.container, this.animatedItems);
    }
  },

  onUnload() {
    if (this.animatedItems.length) {
      this.scrollAnimation.unload();
    }
  },
});
